export const bartOrangeOakland = [
    [37.80345615057081, -122.27161724844689], // BART 12th St Oakland
    [37.80964288766491, -122.26779636346348],
    [37.81020507607589, -122.26771554506628], // BART 19th St Oakland (somewhere here)
    [37.81076311546558, -122.26793439571574], 
    [37.812910130519505, -122.2702246365638],
    [37.813762993521806, -122.27075552644777],
    [37.81495041470212, -122.2709476040355],
    [37.81559572400692, -122.27087417557674],
    [37.82877944557078, -122.26722124623498], // BART MacArthur
];